// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"885b9fc3","437":"6ac0de3f","761":"17982700","892":"00ed4ef7"}[chunkId] + ".chunk.css";
};